// import React, { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { Input } from "antd";
// import { MailFilled } from "@ant-design/icons";
// import LoginLogo from "../../Assets/GodrejLOGO.png";
// import "./ResetPassword.css";
// import useInputs from "../../customhooks/useInputs";
// import ResetPasswordFetch from "../../services/ResetPassword";

// function ResetPassword() {
//   const [searchParams] = useSearchParams();

//   let password = useInputs("");
//   let confirmpassword = useInputs("");
//   const [tokenValue, setTokenValue] = useState("");
//   const navigate = useNavigate();

//   useEffect(() => {
//     for (const entry of searchParams.entries()) {
//       const [param, value] = entry;
//       setTokenValue(value);
//     }
//   }, []);

//   const handleResetPassword = async () => {
//     if (password.value === "") {
//       toast("Password is required");
//     }
//     let passwordRegex = new RegExp(
//       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
//     );
//     if (password.value !== confirmpassword.value) {
//       toast("password mismatch");
//       return;
//     }
//     if (passwordRegex.test(password.value)) {
//       let data = await ResetPasswordFetch({
//         token: tokenValue,
//         password: password.value,
//       });
//       if (data.status == 200) {
//         toast(data.data);
//         navigate("/");
//       } else {
//         toast("Something went wrong");
//       }
//     } else {
//       toast(
//         "Password must be 8 character long or more and has one Uppercase,One LowerCase,One Digit and a special Character."
//       );
//     }
//   };
//   return (
//     <>
//       <div style={{ position: "relative" }}>
//         <img
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             width: "40vh",
//             height: "10vh",
//             marginTop: "1vh",
//           }}
//           src={LoginLogo}
//           alt="Logo"
//         />
//       </div>
//       <div className="LoginDiv">
//         <div className="InputDiv">
//           <div className="InputDivText">
//             <h3>Reset Password</h3>
//           </div>
//           <div className="InputDivInner">
//             <div className="Input">
//               <label>Password</label>
//               <Input
//                 required
//                 prefix={<MailFilled size="10vh" />}
//                 placeholder="Enter Your New Password"
//                 type="password"
//                 value={password.value}
//                 onChange={password.onChange}
//               />
//             </div>
//             <div className="Input">
//               <label>Confirm Password</label>
//               <Input
//                 required
//                 prefix={<MailFilled size="10vh" />}
//                 placeholder="Enter above password for confirm"
//                 value={confirmpassword.value}
//                 onChange={confirmpassword.onChange}
//               />
//             </div>
//             <div className="my-3">
//               <button
//                 type="button"
//                 class="btn btn-dark"
//                 onClick={handleResetPassword}
//               >
//                 Reset Password
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default ResetPassword;

import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Input } from "antd";
import { LockFilled } from "@ant-design/icons";
import LoginLogo from "../../Assets/GodrejLOGO.png";
import useInputs from "../../customhooks/useInputs";
import ResetPasswordFetch from "../../services/ResetPassword";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  let password = useInputs("");
  let confirmpassword = useInputs("");
  const [tokenValue, setTokenValue] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      setTokenValue(value);
    }
  }, [searchParams]);

  const handleResetPassword = async () => {
    if (password.value === "") {
      toast("Password is required");
      return;
    }
    let passwordRegex = new RegExp(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
    );
    if (password.value !== confirmpassword.value) {
      toast("Password mismatch");
      return;
    }
    if (passwordRegex.test(password.value)) {
      let data = await ResetPasswordFetch({
        token: tokenValue,
        password: password.value,
      });
      if (data.status === 200) {
        toast(data.data);
        navigate("/");
      } else {
        toast("Something went wrong");
      }
    } else {
      toast(
        "Password must be 8 characters long or more and include one Uppercase, one Lowercase, one Digit, and a special Character."
      );
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      {/* Logo */}
      <div className="flex justify-center mb-6">
        <img className="w-48 h-auto sm:w-64" src={LoginLogo} alt="Logo" />
      </div>

      {/* Reset Password Form */}
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
        <div className="text-center mb-4">
          <span className="text-xl font-bold text-blue-500">
            Reset Your Password
          </span>
        </div>

        {/* Password Input */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">New Password</label>
          <Input.Password
            required
            prefix={<LockFilled />}
            placeholder="Enter Your New Password"
            value={password.value}
            onChange={password.onChange}
            className="w-full"
            visibilityToggle
          />
        </div>

        {/* Confirm Password Input */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">
            Confirm Password
          </label>
          <Input.Password
            required
            prefix={<LockFilled />}
            placeholder="Confirm Your New Password"
            value={confirmpassword.value}
            onChange={confirmpassword.onChange}
            className="w-full"
            visibilityToggle
          />
        </div>

        {/* Reset Button */}
        <div className="flex items-center justify-between mb-3">
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
            onClick={handleResetPassword}
          >
            Reset Password
          </button>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
